import t from '../actions/actionTypes'

const defaultState = {
	form: {
		school_information: {
			visible: true,
		},
		classroom_information: {
			visible: true,
		},
		assignment_information: {
			visible: true,
		},
	},
	errors: [],
	entities: {},
	current: {
		elements: [],
		notes: {},
		self_paceds: {},
		entityUID: 0,
		page: 0,
		searching_page: -1,
		order_field: 'name',
		order_type: 'asc',
		more: false,
		init: true,
	},
	list: {
		elements: [],
		page: 0,
		order_field: '',
		order_type: '',
		more: true,
	},
	new: {
		value: '',
		error: '',
	},
	onboarding: {
		step: 0,
	},
	codes: [],
	timeFormat: '',
	dateFormat: '',
	actualTimestamp: 0,
}

function setAll(state, action) {
	const newState = {...state}
	newState.list = {...state.list}
	newState.list.page = parseInt(action.payload.result.page) + 1
	newState.list.more = action.payload.result.more

	if (action.payload.result.binders.length) {
		const newArrayElements = action.payload.result.binders.map(b => b.form_data.entityUID)
		if (action.payload.result.page === '0') {
			newState.list.elements = newArrayElements
		} else {
			const filteredElements = newArrayElements.filter(element => state.list.elements.indexOf(element) < 0)
			newState.list.elements = [...state.list.elements, ...filteredElements]
		}

		/*
		TODO: Buscar los entities que ya existen y no pisar los existentes.
		Ver si aplicar un timestamp del lado del server o como hacer.
		*/
		const newObjectEntities = Object.assign(...action.payload.result.binders.map(b => ({[b.form_data.entityUID]: b})))
		newState.entities = {...state.entities, ...newObjectEntities}
	}

	return newState
}

function initializeBindersList(state) {
	const newState = {...state}
	newState.list = {...defaultState.list, ...{order_field: state.list.order_field, order_type: state.list.order_type}}
	return newState
}

function setSearchingPage(state) {
	const newState = {...state}
	newState.current = {...state.current}
	newState.current.searching_page = state.current.page
	return newState
}

function shouldCollapse(form_data, values) {
	let i = 0
	const len = values.length
	while (i < len) {
		if (!form_data[values[i]]) {
			return true
		}
		i += 1
	}
	return false
}

function setBinderData(state, action) {
	const newState = action.entities ? setBinderPresentations(state, action) : {...state}
	if (action.binder) {
		const newEntities = {...state.entities}
		newEntities[action.entityUID] = action.binder
		newState.entities = newEntities
		newState.form = {
			school_information: {
				visible: shouldCollapse(action.binder.form_data, ['school_name', 'school_address', 'school_city', 'school_state', 'school_zip_code']),
			},
			classroom_information: {
				visible: shouldCollapse(action.binder.form_data, ['class_notes', 'emergency_procedures']),
			},
			assignment_information: {
				visible: true,
			},
		}
	}
	return newState
}

function deleteBinderElement(state, action) {
	const newState = {...state}
	const bindersData = {...state.entities}
	bindersData[action.entityUID] = null
	newState.list = {...state.list}
	const indexOfItem = newState.list.elements.indexOf(action.entityUID)
	newState.list.elements = [...state.list.elements.slice(0, indexOfItem), ...state.list.elements.slice(indexOfItem+1)]
	return newState
}

function setBinderPresentations(state, action) {
	const newState = {...state}
	newState.current = {...state.current}

	newState.current.entityUID = action.entityUID
	//This "limit" validation is necessary because this reducer is also used to supply an extra lesson when one is deleted from the binder
	if (!action.limit) {
		newState.current.page = parseInt(action.page) + 1
	}
	newState.current.more = action.more
	newState.current.init = false
	const newArrayElements = action.entities.map(b => b.data.entityUID)
	if (action.page === '0') {
		newState.current.elements = [...newArrayElements]
		newState.current.notes = action.notes
	} else {
		const filteredElements = newArrayElements.filter(element => state.current.elements.indexOf(element) < 0)
		newState.current.elements = [...state.current.elements, ...filteredElements]
		newState.current.notes = {...state.current.notes, ...action.notes}
	}
	return newState
}

function updateBindersSort(state, action) {
	const newState = {...state}
	newState.list = {...state.list, ...action.payload}
	return newState
}

function setBindersSort(state, action) {
	const newState = {...state}
	newState.list = {...state.list, ...action.payload}
	return newState
}

function resetBinderData(state, action) {
	const newState = {...state}
	newState.current = {...defaultState.current, ...{order_field: state.current.order_field, order_type: state.current.order_type, entityUID: action.entityUID}}
	return newState
}

function saveLessonsSuccess(state, action) {
	const newState = {...state}
	newState.current.elements = [...action.presentationUIDs, ...newState.current.elements]
	return newState
}

function deleteLesson(state, action) {
	const newState = {...state}
	const current = {...state.current}

	const indexOfItem = state.current.elements.indexOf(action.presentationUID)
	current.elements = [...state.current.elements.slice(0, indexOfItem), ...state.current.elements.slice(indexOfItem+1)]
	newState.current = current
	return newState
}

function updateNewBinderText(state, action) {
	const newState = {...state, ...{new: {value: action.value, error: ''}}}
	return newState
}

function updateNewBinderFail(state, action) {
	const newState = {...state}
	newState.new = {...state.new, ...{error: action.error}}
	return newState
}

function setLessonNotes(state, action) {
	const newState = {...state}
	const current = {...newState.current}
	const notes = {...state.current.notes, ...{[action.presentationUID]: action.notes}}
	const self_paceds = {...state.current.self_paceds, ...{[action.presentationUID]: action.self_paceds}}
	current.notes = notes
	current.self_paceds = self_paceds
	newState.current = current
	return newState
}

function addNewBinder(state, action) {
	const newState = {...state}
	newState.entities = {...state.entities, ...{[action.payload.form_data.entityUID]: action.payload }}
	const list = {...newState.list}
	const elements = [action.payload.form_data.entityUID, ...state.list.elements]
	list.elements = elements
	newState.list = list
	return newState
}

function resetNewBinderForm(state) {
	const newState = {...state}
	newState.new = {...defaultState.new}
	return newState
}

function toggleFormBox(state, action) {
	const newState = {...state}
	newState.form = {...state.form}
	newState.form[action.name] = {...state.form[action.name]}
	newState.form[action.name].visible = !state.form[action.name].visible
	return newState
}

function uploadDocumentSuccess(state, action) {
	const newState = {...state}
	const binderEntity = {...state.entities[action.entityUID]}
	binderEntity.file = action.name
	newState.entities[action.entityUID] = binderEntity
	return newState
}

function storeErrors(state, action) {
	const newState = {...state}
	newState.errors = action.errors
	return newState
}

function resetValidationErrors(state) {
	const newState = {...state}
	newState.errors = []
	return newState
}

function resetListElements(state) {
	const newState = {...state}
	newState.list = {...state.list}
	newState.list.elements = []
	newState.list.page = 0
	newState.list.more = true
	return newState
}

function goToOnboardingStep(state, action) {
	if (action.step === state.onboarding.step) {
		return state
	}
	const newState = {...state}
	newState.onboarding = {...state.onboarding}
	newState.onboarding.step = action.step
	return newState
}

function updateLessonCodes(state, action) {
	const newState = {...state}
	newState.codes = action.codes
	newState.dateFormat = action.dateFormat
	newState.timeFormat = action.timeFormat
	newState.actualTimestamp = action.actualTimestamp
	return newState
}

function saveBinderFormValues(state, action) {
	const newState = {...state}
	const binderEntity = {...state.entities[action.values.entityUID]}
	binderEntity.form_data = action.values
	newState.entities[action.values.entityUID] = binderEntity
	return newState
}

const bindersReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.BINDERS_SET_ALL: return setAll(state, action)
		case t.BINDERS_GET_BINDER_LESSONS: return setSearchingPage(state, action)
		case t.BINDERS_RESET_BINDER_DATA: return resetBinderData(state, action)
		case t.BINDERS_LESSONS_FETCHED: return setBinderData(state, action)
		case t.BINDERS_SET_BINDER_DATA: return setBinderData(state, action)
		case t.BINDERS_UPDATE_BINDERS_SORT: return updateBindersSort(state, action)
		case t.BINDERS_SET_BINDERS_SORT: return setBindersSort(state, action)
		case t.BINDERS_DELETED_BINDER: return deleteBinderElement(state, action)
		case t.BINDERS_SAVE_LESSONS_SUCCESS: return saveLessonsSuccess(state, action)
		case t.BINDERS_DELETED_LESSON: return deleteLesson(state, action)
		case t.BINDERS_BINDER_CREATE_TEXT_UPDATE: return updateNewBinderText(state, action)
		case t.BINDERS_BINDER_CREATE_FAIL: return updateNewBinderFail(state, action)
		case t.BINDERS_SAVED_NOTES: return setLessonNotes(state, action)
		case t.BINDERS_BINDER_CREATE_NEW: return addNewBinder(state, action)
		case t.BINDERS_BINDER_CREATE_RESET: return resetNewBinderForm(state, action)
		case t.BINDERS_TOGGLE_FORM_BOX: return toggleFormBox(state, action)
		case t.BINDERS_UPLOAD_DOCUMENT_SUCCESS: return uploadDocumentSuccess(state, action)
		case t.BINDERS_STORE_ERRORS: return storeErrors(state, action)
		case t.BINDERS_LOAD_VALIDATIONS: return resetValidationErrors(state)
		case t.BINDERS_SAVE_FORM_SUCCESS: return resetListElements(state)
		case t.BINDERS_ONBOARDING_GO_TO_STEP: return goToOnboardingStep(state, action)
		case t.BINDERS_LESSON_CODES_SUCCESS: return updateLessonCodes(state, action)
		case t.BINDERS_INITIALIZE_LIST: return initializeBindersList(state, action)
		case t.BINDERS_SAVE_SHARE_FORM: return saveBinderFormValues(state, action)
		default: return state
	}
}

export default bindersReducer
